import * as React from 'react';
import Alert, { AlertCategoryEnum } from './Alert';

interface DeviceEncryptionAlertProps {
    show: boolean;
}

export const DeviceEncryptionAlert = ({ show }: DeviceEncryptionAlertProps) => {
    return (
        <Alert show={show} category={AlertCategoryEnum.Warning}> <b>Warning:</b> If you have a policy to encrypt external media enabled on your PC, please ensure that you <b>DO NOT</b> encrypt the VitaloJAK device / card when prompted to do so as this will render the device inoperable.
            <br />
            <br />
            If this has occurred and the VitaloJAK device / card has been encrypted you must contact Vitalograph Technical Support for assistance.
        </Alert>
    );
}
